import { colorSystem } from "goi_common";

const title = "충청 대전 세종 장례 소개 - [고이장례연구소]";

export const parlorRegion = {
  defaultMetaData: {
    pageOgTitle: title,
    pageDescription: `대전 충청 세종 장례식장 안내, 대전 충청 세종 지역 장례식장 비용, 실시간 빈소 정보, 대전 충청 세종 저렴한 장례식장 비용 정보, 장례식장 비교 견적, 혜택 정보 - 고이장례연구소`,
    pageKeywords:
      "대전 장례식장 추천, 충청 장례식장 추천, 세종 장례식장 추천, 장례, 장례식, 가족장, 무빈소장례, 소규모장례, 장례지도사, 장례식장, 장례 비용, 상조, 상조 회사, 상조회, 상조가입, 상조추천, 후불제상조, 장례상조, 상조서비스, 장례식 절차, 장례 절차, 임종, 고인, 빈소, 임종",
    pageOgDescription: `대전 충청 세종 장례식장 안내, 대전 충청 세종 지역 장례식장 비용, 실시간 빈소 정보, 대전 충청 세종 저렴한 장례식장 비용 정보, 장례식장 비교 견적, 혜택 정보 - 고이장례연구소`,
    pageOgImage: "",
  },

  layout: {
    headTitle: title,
    layoutStyle: {
      background: "white",
      borderBottom: "none",
      color: "black",
      height: "60px",
    },
    ctaButtonStyle: {
      border: "none",
      color: "white",
      background: colorSystem.green.c400,
    },
  },

  targetSidos: ["25", "29", "33", "34"],

  regionColor: colorSystem.green,

  bestParlorIds: [77, 522, 536, 1080, 1156],

  baseUrl: "https://www.ch-funeralportal.co.kr",
};
